<div class="unauthorized-page">
  <div class="card">
    <div class="status-pill">Sorry!</div>
    <h1>Unauthorized Access</h1>
    <p>
      Session may have expired.<br/>
      You don’t have permission to view this page.<br/>
      Please log in again or return to the home screen.
    </p>
    <div class="actions">
      <button class="btn secondary" (click)="doLogout()">Logout</button>
      <button class="btn primary" (click)="goHome()">Go Home</button>
    </div>
  </div>
</div>
